function sendGTMEvent(eventName, data = {}, withTimestamps = true) {
  try {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // Take the 20 most recent timestamps
    const timestamps = (window.timestamps || []).slice(-20);
    const event = {
      event: eventName,
      session_id: window.currentSessionId,
      timestamps: withTimestamps ? JSON.stringify(timestamps) : undefined,
      ...data,
    };
    window.dataLayer.push(event);

    console.debug('Sent Google Tag Manager event:', event);
  } catch (e) {
    console.error('Error sending Google Tag Manager event:', e);
  }
}

export { sendGTMEvent };
